import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFeatureFlagsForSecureReviewerQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  flagNames: Array<Types.Scalars['String']['input']>;
}>;


export type GetFeatureFlagsForSecureReviewerQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id: string, featureFlags?: Array<{ __typename?: 'FeatureFlag', name: string, enabled: boolean } | null> | null } | { __typename?: 'IdentifiedUser' } | null };


export const GetFeatureFlagsForSecureReviewer = /*#__PURE__*/ gql`
    query GetFeatureFlagsForSecureReviewer($accountId: ID!, $flagNames: [String!]!) {
  me {
    ... on AuthenticatedUser {
      id
      featureFlags(accountId: $accountId, flagNames: $flagNames) {
        name
        enabled
      }
    }
  }
}
    ` as unknown as DocumentNode<GetFeatureFlagsForSecureReviewerQuery, GetFeatureFlagsForSecureReviewerQueryVariables>;

          

          export const useGetFeatureFlagsForSecureReviewerQuery = (options?:QueryHookOptions<GetFeatureFlagsForSecureReviewerQuery, GetFeatureFlagsForSecureReviewerQueryVariables>) => useQuery(GetFeatureFlagsForSecureReviewer, options);

          

          export type GetFeatureFlagsForSecureReviewerQueryOptions = QueryHookOptions<GetFeatureFlagsForSecureReviewerQuery, GetFeatureFlagsForSecureReviewerQueryVariables>;

          

          export const useGetFeatureFlagsForSecureReviewerLazyQuery = (options?:LazyQueryHookOptions<GetFeatureFlagsForSecureReviewerQuery, GetFeatureFlagsForSecureReviewerQueryVariables>) => useLazyQuery(GetFeatureFlagsForSecureReviewer, options);

          

          export type GetFeatureFlagsForSecureReviewerQueryResult = ReturnType<typeof useGetFeatureFlagsForSecureReviewerQuery>;

          
